export const gujarati = {
  //home
  g1:"ગુજરાત રાજ્ય કૃષિ માર્કેટિંગ બોર્ડ (ગુજરાત મંડી બોર્ડ, GSAMB)",
  g_home:" ગુજરાત રાજ્ય કૃષિ માર્કેટિંગ બોર્ડ (ગુજરાત મંડી બોર્ડ, GSAMB) ની સ્થાપના કૃષિ પેદાશોની ખરીદી, વેચાણ અને સંગ્રહનું નિયમન અને સંચાલન કરવા માટે કરવામાં આવી હતી. તે ખેડૂતો, વેપારીઓ અને ખરીદદારો માટે વાજબી વેપાર પ્રથાઓ સુનિશ્ચિત કરે છે. GSAMB સરળ પુરવઠા શૃંખલા જાળવવા માટે કૃષિ, બાગાયતી, પશુપાલન અને વન ઉત્પાદનોના માર્કેટિંગની દેખરેખ રાખે છે. તે મિલકતોની માલિકી અને સંચાલન કરવાની સત્તા ધરાવતી સ્વતંત્ર સંસ્થા તરીકે કાર્ય કરે છે.",
  q_link:"ઝડપી લિંક્સ",
  trader_reg:"વેપારી નોંધણી",
  panel_reg:" પેનલ એન્જિનિયર નોંધણી",
  g2:"કૃષિ માર્કેટિંગ અને ગ્રામીણ નાણાકીય વ્યવસ્થા નિયામક",
  logout:"લોગઆઉટ",
  lang:"ભાષા",
  main:"મુખ્ય",
  home:"ઘર",
  tra_login:"ટ્રેડર લોગીન",
pa_login:"પેનલ એન્જિનિયર લોગીન",
  gc_login:"GCA લોગીન",
  spon_login:"સ્પોન્સર લોગીન",
dr_login:"જિલ્લા લોગીન",
ap_login:"એપીએમસી લોગીન",
ho_login:"હેડ ઓફિસ લોગીન",

//sidevar
  mis_dash:"MIS ડેશબોર્ડ",
  dash:"ડેશબોર્ડ",
  mis_download:"MIS પૂર્વાવલોકન",
  mis_upload:"MIS અપલોડ",
  utl:"યુનિફાઇડ ટ્રેડર લાઇસન્સ",
  p_eng:"પેનલ એન્જિનિયર",
  t_app:"ટ્રેડર એપ્લિકેશન",
  a_app:"APMC એપ્લિકેશન",
  spon_app:"સ્પોન્સર એપ્લિકેશન",
  registration:"નોંધણી",
  agreement:"કરાર",
  new_reg:"નવી નોંધણી", 
  new_agg:"નવો કરાર",
  my_app:"મારી અરજી",

  new_app:"નવી એપ્લિકેશન",
mu_app:"મારી એપ્લિકેશનો",
pa_eng:"પેનલ એન્જિનિયર એપ્લિકેશન",
pending:"બાકી",
  pen:"tttt",

approved:"મંજૂર",
rejected:"નકારેલ",
app:"એપ્લિકેશન્સ",
  schemeApplication:"એપ્લિકેશન્સ Schemes",
  formApplication:"એપ્લિકેશન્સ Forms",

  


  //mis
  dashboard:"ડેશબોર્ડ",
  app_recev:"અરજીઓ પ્રાપ્ત થઈ",
  y1:"1 વર્ષ",
y3:"3 વર્ષ",
app_pen:" અરજીઓ બાકી છે ",
lic_iss:"લાઈસન્સ જારી કરાયેલ",
amount_collected:"એકત્રિત રકમ",
reg_trader:"રજિસ્ટર્ડ ટ્રેડર",
month_app_rec:"માસિક અરજીઓ પ્રાપ્ત થઈ",
app_rec_aptype:"અરજદારના પ્રકાર દ્વારા પ્રાપ્ત અરજીઓ",
app_summ_apmc:"એપ્લિકેશન્સ સારાંશ એપીએમસી",

app_summ_district:"એપ્લિકેશન્સ સારાંશ જિલ્લો",
app_det:"અરજદારની વિગતો",
reg_eng:"નોંધાયેલ ઇજનેર",
date_app:"લાગુ કર્યાની તારીખ",
  //reistration
  enter_detail:"લાઈસન્સ અરજી માટે વિગતો દાખલ કરો",
  reg_heading:" સાઇન અપ કરવા માટે કૃપા કરીને તમારી વિગતો દાખલ કરો",
  title: "શીર્ષક",
  applicantName:"અરજદારનું નામ",
  first_name: "પ્રથમ નામ",
  middle_name: "મધ્ય નામ",
  last_name: "છેલ્લું નામ",
  gender: "જાતિ",
  registration_type: "તરીકે સભ્ય નોંધણી એ",
  applicant_type: "અરજદારનો પ્રકાર",
  entityType:"અરજદારનો પ્રકાર",
  mobile: "મોબાઈલ નં",
  email: "ઈમેલ આઈડી",
  password: "પાસવર્ડ",
  confirm_password: "પાસવર્ડની પુષ્ટિ કરો",
  sign_up: "સાઇન અપ કરો",
  enter_otp: "OTP દાખલ કરો",
  verify: "ચકાસો અને આગળ વધો",
  resend:"OTP ફરીથી મોકલો",
  get_otp:"OTP મેળવો",
  otp_heading:"તમારા એકાઉન્ટની માલિકીની પુષ્ટિ કરવા માટે કૃપા કરીને તમારા ઈ-મેલ પર પ્રાપ્ત થયેલ OTP દાખલ કરો.",
  alreadyaccount:"પહેલેથી ખાતું છે?",
  organisation:"સંસ્થા",

  //login
  login:"સભ્ય લૉગિન",
  login_heading:"સાઇન ઇન કરવા માટે કૃપા કરીને તમારી વિગતો દાખલ કરો",
  username: "વપરાશકર્તા નામ",
  sign_in: "સાઇન ઇન કરો",
  forgot_password: "પાસવર્ડ ભૂલી ગયા છો",
  remember:"મને યાદ રાખો",
  create_account: "એકાઉન્ટ બનાવો",
  request_again: "ફરી વિનંતી",
  dontaccount:"ખાતું નથી?",
  //steps of license application form
  basic_detail: "મૂળભૂત વિગતો",
  representatives: "પ્રતિનિધિઓ",
  firm_info: "પેઢી માહિતી",
  guarantors: "બાંયધરી આપનાર",
  enclosures: "બિડાણ અને ઘોષણાઓ",
  payment: "ચુકવણી",
  license:"નવી લાઇસન્સ અરજી",
  //basic details form
  trader_name: "વેપારીનું નામ",
  register_with_apmc: "એપીએમસી સાથે નોંધણી કરો",
  placeOfBusiness:"વ્યવસાયનું સ્થળ",
  license_type: "લાઇસન્સનો પ્રકાર",
  current_address: "વર્તમાન સરનામું",
  currAddress:"વર્તમાન સરનામું",
  permanent_address: "કાયમી સરનામું",
  "Permanent Address" :"કાયમી સરનામું",
  perAddress:"કાયમી સરનામું",
  registered_office_address: "રજિસ્ટર્ડ ઓફિસ સરનામું",
  regOffAddress:"રજિસ્ટર્ડ ઓફિસ સરનામું",
  address: "સરનામું",
  at:"સરનામું",
  post: "પોસ્ટ",
  taluka: "તાલુકો",
  district: "જિલ્લો",
  borderDistrict:"સરહદી જિલ્લા",
  pan_card_no: "પાન કાર્ડ નં",
  election_card_no: "ચૂંટણી કાર્ડ નં",
  electionCardNo:"ચૂંટણી કાર્ડ નં",
  registered_email_id: "રજિસ્ટર્ડ ઈમેલ આઈડી",
  regEmailId:"રજિસ્ટર્ડ ઈમેલ આઈડી",
  bankDetails: "બેંક વિગતો",
  acct_no: "બેંક ખાતા નં",
  ifsc_code: "IFSC કોડ",
  acct_type : "ખાતાનો પ્રકાર",
  bank_name : "બેંકનું નામ",
  branch_name: "શાખાનું નામ",
  agentName: "એજન્ટનું નામ",
  otherDoc:"વધારાના અન્ય દસ્તાવેજો",


  //buttons
  next: "આગળ",
  previous: "ગત",
  submit: "સબમિટ કરો",
  cancel: "સાચવો અને પછીથી ચૂકવણી કરો",
  ok:"ઠીક",
  can:"રદ કરો",
  retry_payment:"ચુકવણીનો ફરી પ્રયાસ કરો",
  download:"રસીદ ડાઉનલોડ કરો",
  add_more: "વધુ ઉમેરો",
  delete:"કાઢી નાખો",
  preview:"પૂર્વાવલોકન",
  view:"જુઓ",
  review:"સમીક્ષા",
  preview_application: "પૂર્વાવલોકન એપ્લિકેશન",
  make_your_payment: "હવે ચૂકવો",
  upload: "અપલોડ કરો",
  modify: "ફેરફાર કરો",
  ptp:"ચુકવણી માટે આગળ વધો",
  edit:"સંપાદિત કરો",
  close:"બંધ કરો",
  down:"ડાઉનલોડ કરો",
  vdoc:"દસ્તાવેજ જુઓ",
  vdocs:"દસ્તાવેજો જુઓ",
upd:"અપડેટ",
remove:"દૂર કરો",
down_pdf:"પીડીએફ ડાઉનલોડ કરો",
  //representative
  name: "નામ",
  age_in_year: "વર્ષની ઉંમર",
  representative:"પ્રતિનિધિઓ અથવા સહાયકો",
  representative_heading: "પ્રતિનિધિ અથવા સહાયકોની મથાળું",
  representative_details: "લાઇસન્સ અરજી માટે પ્રતિનિધિઓ અથવા સહાયકોની વિગતો દાખલ કરો.",

  //firm info form
  firm:"ભાગીદારો/સભ્યો",
  firmDetails:"માહિતી",
  firm_heading: "ભાગીદારો અથવા સભ્યોની મથાળું",
  firm_details: "જો અરજદાર સહકારી મંડળી, કંપની, પેઢી અથવા સંયુક્ત પરિવાર હોય",
  firm_name: "પેઢી/સહકારી મંડળી/કંપનીનું નામ",
  entityName:"પેઢી/કંપની/સહકારી મંડળી/અન્ય સંસ્થા",
  firm_gst_no:
    "GST નંબર (જો અરજદાર સહકારી મંડળી, પેઢી, કંપની અથવા અન્ય એન્ટિટી હોય.)",
  entityGstNo:"GST નંબર (પેઢી/કંપની/સહકારી મંડળી/અન્ય સંસ્થા) ",
  entityFpoNo:"FPO નં.(પેઢી/કંપની/સહકારી મંડળી/અન્ય સંસ્થા)",
  
  firm_registration_no:
    "નોંધણી નંબર (જો અરજદાર સહકારી મંડળી, પેઢી, કંપની અથવા અન્ય સંસ્થા હોય.)",
    
    entityRegistrationNo:
  "નોંધણી નંબર (પેઢી/કંપની/સહકારી મંડળી/અન્ય સંસ્થા)",
  firm_pan_no:
    "પાન નંબર (જો અરજદાર સહકારી મંડળી, ફર્મ, કંપની અથવા અન્ય એન્ટિટી હોય.)",
  entityPanNo:  "પાન નંબર (પેઢી/કંપની/સહકારી મંડળી/અન્ય સંસ્થા)",
  fpo: "FPO (ખેડૂત ઉત્પાદક સંગઠન) પ્રમાણપત્ર (જો લાગુ હોય તો)",
  //guarantors form
  guarantor:"ગેરંટી આપનારની વિગતો",
  guarantor_heading: "ગેરંટરની વિગતો ભરો:",
  guarantors_details: "લાઇસન્સ અરજી માટે ગેરંટરની વિગતો દાખલ કરો",
  "guarantorPanCard": "પાન કાર્ડની નકલ અપલોડ કરો",
  "guarantorPhoto": "પ્રોફાઇલ ફોટો અપલોડ કરો",
  "guarantorSignature": "સહી અપલોડ કરો",
  "guarantorDeclaration": "ઘોષણા અપલોડ કરો",
  //enclosure form
  attachements: "જોડાણો",
  enclosures_heading: "લાઇસન્સ અરજી માટે સહાયક દસ્તાવેજો પ્રદાન કરો-",
  "solvencyCertificate": "સોલ્વન્સી પ્રમાણપત્ર",
  "bankGuarntee": "બેંક ગેરંટી",
  "bankBalanceCertificate": "બેંક બેલેન્સ પ્રમાણપત્ર",
  "panCardNo":"પાન કાર્ડ",  
  "panCard":"પાન કાર્ડ",

  "itReturns": "આઇટી રિટર્નની નકલો (છેલ્લા ત્રણ વર્ષથી)",
  "itReturns_1": "આઇટી રીટર્ન",
  "itReturns_2": "આઇટી રીટર્ન",
  "itReturns_3": "આઇટી રીટર્ન",
  "itReturnDetail":"આઇટી રિટર્નની નકલો (છેલ્લા ત્રણ વર્ષથી)",
  declarationDetail:"ઘોષણા",
  "electionCard": "ચૂંટણી કાર્ડની નકલ",
  "chalanPayementLiceneseFeeDoc": "લાઇસન્સ ફીની ચુકવણીના સમર્થનમાં ચલણ",
  "proofOfBusinessPalace": "વ્યવસાયના સ્થળનો પુરાવો",
  "partnerShipDeed": "ભાગીદારી પેઢીના કિસ્સામાં, ભાગીદારી દસ્તાવેજની નકલ",
  "traderSignature": "વેપારીની સહી",
  agentSignature:"એજન્ટની સહી",
  gstCertificateDocs:"GST પ્રમાણપત્ર",
  "declarations": "ઘોષણા",
  "enclousreDeclaration": "બિડાણો ઘોષણા",
  "affidavit":
    "અરજદાર જ્યાં બજાર સમિતિની ચૂંટણી લડવાનો પ્રસ્તાવ મૂકી રહ્યો છે તે વ્યવસાયનું સંભવિત સ્થળ અને બજાર સમિતિની વિગતો દર્શાવતું સોગંદનામું.",
  "coOpSocietyByLaws":
    "સહકારી મંડળીના કિસ્સામાં, નોંધણી પ્રમાણપત્રની નકલ, પેટા-નિયમોની નકલ, લાઇસન્સ મેળવવા માટેના ઠરાવની નકલ, છેલ્લા ઓડિટ રિપોર્ટની નકલ, છેલ્લા ત્રણ વર્ષના આવક-ખર્ચના નિવેદન અને બેલેન્સ શીટની નકલ.",
  "companyArticleAssociation":
    "કંપનીના કિસ્સામાં, સંગઠનના લેખની નકલ અને અધિકૃત વ્યક્તિના પાવર ઓફ એટર્નીની નકલ.",
    payment_heading:"લાઇસન્સ અરજી માટે ચુકવણી વિગતો",
  payment_successfull: "સફળતાપૂર્વક સબમિટ કરવામાં આવ્યું છે.",
  amount: "રકમ",
  transaction_id: "ટ્રાન્ઝેક્શન આઈડી",
  transaction_time: "વ્યવહાર  સમય",
  application_list:"એપ્લિકેશન સૂચિ",
  transaction_declined: "વ્યવહાર નકાર્યો",
  period_of_license: "લાયસન્સની અવધિ",
  enclosure: "બિડાણો",
  photo: "ફોટો",
  Signature: "સહી",
  application_id: "એપ્લિકેશન ID",
  license_period: "લાઇસન્સ અવધિ",
  apmc: "એપીએમસી",
  applied_date: "લાગુ તારીખ",
  application_status: "એપ્લિકેશન સ્થિતિ",
  action: "ક્રિયા",
  payment_status: "આભાર! તમારી અરજી",
  
payment_s:"માફ કરશો! તમારી ચુકવણી નિષ્ફળ ગઈ છે. કૃપા કરીને તમારી ચુકવણીનો ફરી પ્રયાસ કરો.",
  download_license: "લાયસન્સ ડાઉનલોડ કરો",
  license_validity: "સુધીની લાઇસન્સ માન્યતા",
  download_nc_report: "NC રિપોર્ટ ડાઉનલોડ કરો",
  commentt:"ટિપ્પણીઓ સમયરેખા",
  comment:"ટિપ્પણી",
  c_by:"દ્વારા ટિપ્પણી:",
  view_comment: "એપ્લિકેશન સ્થિતિ",
  approve: "મંજૂર",
  decline: "નકાર",
  identified_issues: "ઓળખાયેલ સમસ્યાઓ",
  make_corection: "કરેક્શન કરો",
  add_comment: "ટિપ્પણી ઉમેરો",
  forward: "માટે ફોરવર્ડ",
  select_action: "ક્રિયા પસંદ કરો",
  add: "ઉમેરો",
  reset: "રીસેટ કરો",
  record_issues: "મુદ્દાઓ રેકોર્ડ કરો અને ટિપ્પણી ઉમેરો",
  upload_nc: "NC (નોન કન્ફોર્મન્સ) રિપોર્ટ અપલોડ કરો",
  tap:"વેપારી એપ્લિકેશન પૂર્વાવલોકન",
  app_details:"અરજી વિગતો",
  fee:"લાઇસન્સ ફી ",
  fees:"ની લાઇસન્સ ફી ",
  year:"વર્ષ",
  upf:"પીડીએફ ફાઈલ અપલોડ કરો",
  usl:"સીલબંધ લાઇસન્સ અપલોડ કરો",
  dul:"અનસાઇન્ડ લાઇસન્સ ડાઉનલોડ કરો",
  approvedunsigned_h1:"આ લાઇસન્સ જિલ્લા રજિસ્ટ્રાર દ્વારા મંજૂર કરવામાં આવ્યું છે. વેપારીને સીલબંધ લાઇસન્સ આપવા માટે વધારાના પગલાં જરૂરી છે.",
  approvedunsigned_h1_GCA:"આ લાઇસન્સ જિલ્લા રજિસ્ટ્રાર દ્વારા મંજૂર કરવામાં આવ્યું છે. GCA સીલબંધ લાઇસન્સ આપવા માટે વધારાના પગલાં જરૂરી છે.",
  approvedunsigned_h2:"વેપારીને સીલબંધ લાઇસન્સ આપવાના પગલાં:",
  approvedunsigned_h2_GCA:"GCA ને સીલબંધ લાઇસન્સ આપવાના પગલાં:",
  approvedunsigned_s1:"મંજૂર થયેલ સહી વગરનું લાઇસન્સ ડાઉનલોડ કરો",
  approvedunsigned_s2:"અધિકૃત અધિકારીની સહી મેળવો અને સત્તાવાર સીલ લગાવો.",
  approvedunsigned_s3:"સીલબંધ અને સહી કરેલ લાઇસન્સ સિસ્ટમ પર અપલોડ કરો.",
  approvedunsigned_panel_h1:"આ લાઇસન્સ ડિરેક્ટર દ્વારા મંજૂર કરવામાં આવ્યું છે. પેનલને સીલબંધ લાઇસન્સ જારી કરવા માટે વધારાના પગલાં જરૂરી છે.",
  approvedunsigned_panel_h2:"પેનલને સીલબંધ લાઇસન્સ આપવા માટેના પગલાં:",
  upload_doc:"દસ્તાવેજો અપલોડ કરો",
  re_info:"જરૂરી માહિતી",
  reu_info:"તમારી અરજી નકારવામાં આવી છે, કૃપા કરીને અરજી ફરીથી સબમિટ કરવા માટે નીચેની માહિતી આપો.",
  track_app:"ટ્રેક એપ્લિકેશન ",
  rej_da:"રીક્વેરી સબમિશન માટે ડેટા નકારો",
  rej_doc:"રીક્વેરી સબમિશન માટે દસ્તાવેજો નકારો",
  dlusl: "લાઇસન્સ ડાઉનલોડ કરો અને સહી કરેલ લાઇસન્સ અપલોડ કરો",
  order_id:"ઓર્ડર ID",

  //panel engineer
  DOB:"જન્મ તારીખ",
  dob:"જન્મ તારીખ",
  education_details:"શિક્ષણ વિગતો",
  address_details:"સરનામાંની વિગતો",
  enter_details:"લાઇસન્સ અરજી માટે વિગતો દાખલ કરો",
  secondaryDistrict:"માધ્યમિક જિલ્લો",
  full_address:"સંપૂર્ણ સરનામું",
  applicant_name:"અરજદારનું નામ",
  panel_n:"પેનલ એન્જિનિયરનું નામ",
  add_partner:"ભાગીદાર ઉમેરો",
  partnership_firm:"શું આ ભાગીદારી પેઢી છે?",
  partner_details:"ભાગીદાર વિગતો",
  add_partner_details:"ભાગીદાર વિગતો ઉમેરો",
  save_partner:"જીવનસાથી સાચવો",
  age:"ઉંમર",
  fill:"ભરો",
  fill_education:"શિક્ષણની વિગતો ભરો",
  education:"અભ્યાસ-શૈક્ષણીક લાયકાત",
  attested_copy:"પ્રમાણિત નકલ જોડવાની રહેશે",
  experience_details:"અનુભવની વિગતો",
  h_experience_details:"પુરાવાની પ્રમાણિત નકલ જોડો (માસ્ટર ડિગ્રીના કિસ્સામાં ઓછામાં ઓછા 4 વર્ષના પુરાવા/સ્નાતક ડિગ્રીના કિસ્સામાં ઓછામાં ઓછા 5 વર્ષના પુરાવા) ",
  project_name:"પ્રોજેક્ટનું નામ",
  project_awarded_by:"પ્રોજેક્ટ એનાયત કરનાર",
  start_date:"પ્રારંભ તારીખ",
  end_date:"સમાપ્તિ તારીખ",
  projectAwardedby:"Project Awarded By",
  business_engineer:"કેટલા વર્ષથી ધંધાદારી ઇજનેર તરીકે કામ કરે છે.",
  it_returns:"છેલ્લા ત્રણ વર્ષના આઇ.ટી. રિટર્ન",
  h_work_performed:"સરકારી કે અર્ધસરકારી કચેરીના કાર્યો કરેલ હોય તો તેની વિગત (વર્ષ વાર પ્રોજેક્ટના નામ)",
  work_performed:"કામગીરીની વિગતો",
  done_construction:"પૂર્ણ બાંધકામ વિગતો",
  h_done_construction:"બજાર સમિતિ અને જાહેર સંસ્થામાં બાંધકામ કરેલ હોય તો તેની વિગત આધાર સહિત જણાવવી (વર્ષવાર બજાર સમિતિનું પ્રોજેક્ટ નામ/જાહેર સંસ્થાનું પ્રોજેક્ટ નામ)",
  applicant_declaration:"અરજદારની ઘોષણા",
  submit_application:"અરજી સબમિટ કરો",
  done:"થઈ ગયું",
  submitted_successfully:"સફળતાપૂર્વક સબમિટ કર્યું",
  attachement:"જોડાણ",
  download_sealed_license:"સીલબંધ લાઇસન્સ ડાઉનલોડ કરો",
  upload_sealed_license:"સીલબંધ લાઇસન્સ અપલોડ કરો",
  profile_score:"પ્રોફાઇલ સ્કોર",
  panel_engineer_preview:"પેનલ એન્જિનિયર એપ્લિકેશન પૂર્વાવલોકન",
  complete:"કૃપા કરીને તમારી અરજી પૂર્ણ કરો",
Down_lic:"લાઇસન્સ ડાઉનલોડ કરો",
ex_gst:"GST સિવાય",
status:"સ્થિતિ",

experienceDoc_1:"અનુભવ વિગતો એક",
experienceDoc_2:"અનુભવ વિગતો બે",
experienceDoc_3:"અનુભવ વિગતો ત્રણ",
workPerformanceDoc_1:"કાર્ય પૂર્ણ વિગતવાર એક",
workPerformanceDoc_2:"કાર્ય પૂર્ણ વિગતો બે",
workPerformanceDoc_3:"કાર્ય પૂર્ણ વિગતો ત્રણ",
constructionDocs_1:"બાંધકામ થઈ ગયું વિગતો એક",
constructionDocs_2:"બાંધકામ પૂર્ણ થયું વિગતો બે",
constructionDocs_3:"બાંધકામ પૂર્ણ વિગતો ત્રણ",
support:"આધાર",
help_supp:"મદદ અને સમર્થન",
sel_role:"ભૂમિકા પસંદ કરો",
dist_reg:"જિલ્લા રજિસ્ટ્રાર",
ho_office:"મુખ્ય કાર્યાલય",
issue:"મુદ્દાઓ",

return_to:"પર પાછા ફરો",
forgot_head: "જો તમે તમારો પાસવર્ડ ભૂલી ગયા છો, તો અમે તમને તમારો પાસવર્ડ રીસેટ કરવા માટે એક OTP ઇમેઇલ કરીશું.",
sel_tit:"શીર્ષક પસંદ કરો",
mr:"શ્રી.",
mrs:"શ્રીમતી.",
miss:"મિસ.",
sel_gen:"લિંગ પસંદ કરો",
male:"પુરુષ",
 female:"સ્ત્રી",
 other:"અન્ય",
 
sel_app_type:"અરજદાર પ્રકાર પસંદ કરો",
individual:"વ્યક્તિગત",
company:"કંપની",
 fir:"પેઢી",
 co_soc:"સહકારી સમાજ",
fpoo:"ખેડૂત ઉત્પાદક સંગઠન (FPO)",
ge:"સરકારી સંસ્થા",
ngo:"બિન-સરકારી સંગઠન (NGO)",
pa_fir:" ભાગીદારી પેઢી",
llp:"મર્યાદિત જવાબદારી ભાગીદારી (LLP)",
trust:"ટ્રસ્ટ",
jv:"સંયુક્ત સાહસ",
dgto:"OTP મળ્યો નથી",
res_pass:"પાસવર્ડ રીસેટ કરો",
verifying:"ચકાસણી",
en_otp:" OTP દાખલ કરો",
succ:"સફળતા",
bts:"સાઇન-ઇન પર પાછા",
p_reset:"તમારો નવો પાસવર્ડ સફળતાપૂર્વક સાચવવામાં આવ્યો છે.",
sel_qual:"લાયકાત પસંદ કરો",
hs:"હાઈસ્કૂલ",
yrOfExpAsBusErr:"બિઝનેસ એન્જિનિયર તરીકેનો અનુભવ વર્ષ",
highSchool:"હાઈસ્કૂલ",
diploma:"ડિપ્લોમા",
bd:"સ્નાતકની ડિગ્રી",
bachelorDegree:"સ્નાતકની ડિગ્રી",
phd:"પીએચડી",
md:"માસ્ટર ડિગ્રી",
mastersDegree:"માસ્ટર ડિગ્રી",
file_type:"મંજૂર ફાઇલ પ્રકારો: PDF, JPG, JPEG અને મહત્તમ કદ: 3MB અને ન્યૂનતમ કદ: 40KB",
uf:"અપલોડ કરેલી ફાઇલ",
fn:"ફાઇલનું નામ",
dn: "દસ્તાવેજનું નામ",
tra_ph:"વેપારીનો ફોટો",

relevant_doc:"સંબંધિત દસ્તાવેજ અપલોડ કરો",
struct_eng:"શું તમે સ્ટ્રક્ચરલ એન્જિનિયર છો?",
structuralDetail:"Structural Engineer",
specialization:"વિશેષતા",
mobileNo:"મોબાઇલ નંબર",
 guarantorPanCard_1:"Guarantor 1 Pan Card",
  guarantorPanCard_2:"Guarantor 2 Pan Card",
  guarantorPhoto_1:"Guarantor 1 Photo",
  guarantorPhoto_2:"Guarantor 2 Photo",
  guarantorSignature_1:"Guarantor 1 Signature",
  guarantorSignature_2:"Guarantor 2 Signature",
  guarantorDetail_2:"Guarantor 2 Details",
  guarantorDetail_1:"Guarantor 1 Details",
  structureErrDoc: "સાંગઠનિક ઈજનેર",
  apmc_name:"APMC નામ",
  
};